<template>
  <v-container class="login-logo" align="center">
    <v-row justify="center">
      <v-col align="center">
        <v-img width="100%" :src="require('@/assets/kiratik/demofoodshop.svg')" />
        <div class="text-h6 text--secondary">MANUAL PANEL</div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  name: 'LoginLogo.vue',
});
</script>

<style scoped></style>
